// src/redux/coach/coachAPI.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Coach (FormData)
export const addCoachAPI = async (formData) => {
  try {
    const response = await apiService.postFormData(endpoints.addCoach, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Coach (FormData)
export const updateCoachAPI = async ({ id, formData }) => {
  try {
    const response = await apiService.putFormData(`${endpoints.updateCoach}/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Coach List (Paginated)
export const getCoachListAPI = async ({ page = 1, limit = 10, search = "" } = {}) => {
  try {
    const params = { page, limit, search };
    const response = await apiService.get(endpoints.getCoachList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Coach Detail
export const getCoachDetailAPI = async (id) => {
  try {
    const response = await apiService.get(endpoints.getCoachDetail, { id });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get All Coaches (No Pagination) with excludeCompany
export const getCoachListAllAPI = async ({ excludeCompany } = {}) => {
  try {
    const response = await apiService.get(endpoints.getCoachListAll, { excludeCompany });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Assign Coaches to Company
export const assignCoachAPI = async ({ companyId, coachIds }) => {
  try {
    const response = await apiService.post(
      `${endpoints.assignCoach}/${companyId}`,
      { coachIds }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Coach
export const deleteCoachAPI = async (id) => {
  try {
    const response = await apiService.delete(`${endpoints.deleteCoach}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Associated Companies (No ID passed, handled by backend)
export const getAssociatedCompaniesAPI = async () => {
  try {
    const response = await apiService.get(endpoints.companiesAssociatedCoach);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Companies associated with a coach (paginated)
export const getCoachCompaniesAPI = async ({ coachId, page = 1, limit = 10, search = "" } = {}) => {
  try {
    const url = endpoints.getCoachCompanies.replace('{coachId}', coachId);
    const params = { page, limit, search };
    const response = await apiService.get(url, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ NEW: Get Companies by Month for a Coach
export const getCoachCompaniesByMonthAPI = async (coachId) => {
  try {
    const url = endpoints.getCoachCompaniesByMonth.replace('{coach_id}', coachId);
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};